/**
 * AI.GEN lines=1-28
 * Context 上下文管理
 */
import { ContextBase } from '@hpfe/common-base';

import { Config } from '@/context/config';
import { Permission } from '@/context/permission';
import { Request } from '@/context/request';
import { User } from '@/context/user';

const config = new Config();
const user = new User();
const permission = new Permission();
const request = new Request();

export const context = new (class extends ContextBase {
  config = config;
  user = user;
  permission = permission;
  request = request;

  constructor() {
    super({ config, user });

    // 延迟注入
    user.init({ config });
    permission.init({ user });
    request.init({ config, user });
  }
})();
